"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var saleStatus;
(function (saleStatus) {
    saleStatus[saleStatus["created"] = 0] = "created";
    saleStatus[saleStatus["estimation"] = 1] = "estimation";
    saleStatus[saleStatus["waiting"] = 2] = "waiting";
    saleStatus[saleStatus["advance"] = 3] = "advance";
    saleStatus[saleStatus["advanceProcess"] = 4] = "advanceProcess";
    saleStatus[saleStatus["advanceKeeped"] = 5] = "advanceKeeped";
    saleStatus[saleStatus["soldProcess"] = 6] = "soldProcess";
    saleStatus[saleStatus["canceled"] = 7] = "canceled";
    saleStatus[saleStatus["credit"] = 8] = "credit";
    saleStatus[saleStatus["sold"] = 9] = "sold";
    saleStatus[saleStatus["failed"] = 10] = "failed";
})(saleStatus || (saleStatus = {}));
